import { updateOnboardingStatus } from '@/services/user.service';
import { ONBOARDING_VIDEO_EMBED_LINK } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/onboarding';
import { useDispatch, useSelector } from 'react-redux';

import { setOnboaringStatus, setOnboaringStep } from '../../../redux/onboarding/onboardingActions';
import { Mixpanel } from '../../../utils/mixpanel';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import ModalComponent from '../ModalComponent/ModalComponent';

export default function OnboardingStartModal({ show }) {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);

  const handleFinish = async () => {
    Mixpanel.identify(userDetails?._id);
    Mixpanel.people.set({
      'Percentage Tour Completed': 100,
    });
    updateOnboardingStatus();
    dispatch(setOnboaringStatus(true));
    dispatch(setOnboaringStep(999));
    document.querySelector('.root-overlay-container').style.display = 'none';
  };
  return (
    <ModalComponent show={show} width={650} onClose={handleFinish} showCloseIcon={true} style={{ zIndex: 9999 }}>
      <div className="warning-modal modal-main-content">
        <h2>Welcome to SARAL!</h2>
        <p className="enter-list-name">Check out this walkthough to see what you can do with SARAL</p>
        <div
          style={{
            width: '100%',
            height: '100%',
            margin: '10px',
            padding: '5px',
          }}>
          <iframe
            src={ONBOARDING_VIDEO_EMBED_LINK}
            title="SARAL Influencer Marketing OS (Private) Walkthrough Video"
            allow="autoplay; fullscreen"
            allowtransparency="true"
            frameborder="0"
            scrolling="no"
            class="wistia_embed"
            name="wistia_embed"
            msallowfullscreen="true"
            width="100%"
            height="100%"></iframe>
        </div>

        <div className="start-tour-button-container">
          <ButtonComponent
            variant="primary"
            style={{ color: '#fff', width: 120 }}
            onClick={() => {
              Mixpanel.identify(userDetails?._id);
              Mixpanel.people.set({
                'Percentage Tour Completed': 0,
              });
              dispatch(setOnboaringStep(1));
            }}>
            Start Tour
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
